export const PAGES = [
  {
    tab: true,
    name: 'audio',
    text: 'Аудиоуроки'
  },
  {
    tab: true,
    name: 'songs',
    text: 'Песни'
  },
  {
    tab: true,
    name: 'games',
    text: 'Приложения'
  },
  {
    tab: true,
    smartbook: true,
    floatingNav: true,
    name: 'video',
    text: 'Видеоуроки'
  },
  {
    tab: true,
    smartbook: true,
    floatingNav: true,
    name: 'avatar',
    text: 'Кабинет Аватара'
  },
  {
    tab: true,
    smartbook: true,
    floatingNav: true,
    name: 'shop',
    text: 'Магазин Аватара'
  },
  {
    tab: true,
    smartbook: true,
    floatingNav: true,
    name: 'roundup',
    text: 'Контрольные уроки'
  },
  {
    hideOnHomePage: true,
    name: 'parent-info'
  },
  {
    hideOnHomePage: true,
    name: 'mode-info'
  },
  {
    hideOnHomePage: true,
    name: 'tails'
  }
]
